import createVueComponent from '../createVueComponent';

const ChevronUp = createVueComponent('ChevronUpIcon', [
  ['polyline', { points: '18 15 12 9 6 15' }],
]);

export default ChevronUp;
